import { defineStore } from "pinia";
import { useAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationProductBrand = defineStore("curation-setting-product-brand-field", () => {
  const field = useAdditionalServiceField({
    id: "product_brand",
    functionalGroupCode: "PRODUCT_BRAND",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("product_brand");

  return { ...field, hasUnpublishedChange };
});
